import { useState } from "react";
import axios from "axios";
import { X, UserPlus, Loader2, MailCheck, MailWarning, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AddArtistModal = ({ token, onClose, onCreated }) => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [bandName, setBandName] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const [created, setCreated] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSaving(true);
    try {
      const { data } = await axios.post(
        `${API}/admin/artist`,
        { full_name: fullName, email, band_name: bandName },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCreated(data);
      setSaving(false);
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Could not create artist. Please try again.");
      setSaving(false);
    }
  };

  if (created) {
    return (
      <div className="feed-modal-backdrop" onClick={() => onCreated(created.record_id)} data-testid="add-artist-modal">
        <div className="share-sheet" onClick={(e) => e.stopPropagation()}>
          <div className="feed-modal-head">
            <div>
              <p className="feed-modal-kicker">ARTIST CREATED</p>
              <h3 className="feed-modal-title">{fullName} is on the roster</h3>
            </div>
          </div>
          <div className={`feed-status ${created.welcome_email_sent ? "is-live" : "is-hidden"}`} data-testid="welcome-email-status">
            {created.welcome_email_sent
              ? <><MailCheck size={16} style={{ verticalAlign: "-3px", marginRight: 8 }} />Welcome email sent to {email.trim().toLowerCase()} with a link to set up their portal.</>
              : <><MailWarning size={16} style={{ verticalAlign: "-3px", marginRight: 8 }} />Record created, but the welcome email could not be sent. You can resend it from the artist page.</>}
          </div>
          <div className="share-actions" style={{ marginTop: 18 }}>
            <button className="share-btn share-primary" onClick={() => onCreated(created.record_id)} data-testid="add-artist-open-btn">
              OPEN ARTIST RECORD <ArrowRight size={16} />
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="feed-modal-backdrop" onClick={() => !saving && onClose()} data-testid="add-artist-modal">
      <form className="share-sheet" onClick={(e) => e.stopPropagation()} onSubmit={submit}>
        <div className="feed-modal-head">
          <div>
            <p className="feed-modal-kicker">NEW SIGNING</p>
            <h3 className="feed-modal-title">Add an artist to the roster</h3>
          </div>
          <button type="button" className="feed-modal-close" onClick={onClose} disabled={saving} data-testid="add-artist-close">
            <X size={18} />
          </button>
        </div>

        <div className="control-group">
          <label className="control-label">FULL NAME *</label>
          <input className="control-input" value={fullName} onChange={(e) => setFullName(e.target.value)} required autoFocus data-testid="add-artist-name" />
        </div>
        <div className="control-group">
          <label className="control-label">EMAIL ADDRESS *</label>
          <input className="control-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="add-artist-email" />
          <p className="adjust-hint">They'll receive a branded welcome email at this address with a link to set up their portal.</p>
        </div>
        <div className="control-group">
          <label className="control-label">BAND / ACT</label>
          <input className="control-input" value={bandName} onChange={(e) => setBandName(e.target.value)} data-testid="add-artist-band" />
        </div>

        {error && <div className="auth-error" data-testid="add-artist-error">{error}</div>}

        <div className="share-actions">
          <button type="submit" className="share-btn share-primary" disabled={saving} data-testid="add-artist-submit">
            {saving ? <Loader2 size={16} className="spin" /> : <UserPlus size={16} />} {saving ? "CREATING..." : "CREATE ARTIST"}
          </button>
        </div>
      </form>
    </div>
  );
};
